import {
  rtkQueryErrorLogger,
  serviceUnavailableMiddleware,
  unauthenticatedMiddleware,
} from '@app/middlewares';
import authReducer, { authApi } from '@reducers/auth';
import { billingMiddlewares, billingReducers } from '@reducers/billing';
import { capacityMiddlewares, capacityReducers } from '@reducers/capacity';
import dashboardReducer, { dashboardApi } from '@reducers/dashboard/dashboard';
import { areaApi, countryApi } from '@reducers/geo';
import numberReducer, { numberApi } from '@reducers/number/number';
import { orderMiddlewares, orderReducers } from '@reducers/order';
import { planMiddlewares, planReducers } from '@reducers/plan';
import productReducer, { productApi } from '@reducers/product/product';
import profileReducer, { profileApi } from '@reducers/profile/profile';
import reportsReducer, { reportsApi } from '@reducers/reports/reports';
import { reducer as systemReducer, systemApi } from '@reducers/system';
import ticketReducer, { ticketApi } from '@reducers/tickets/tickets';
import userBalanceReducer from '@reducers/user/balance';
import { userContactsApi } from '@reducers/user/contacts';
import userReducer, { userApi } from '@reducers/user/user';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

const store = configureStore({
  reducer: {
    system: systemReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    number: numberReducer,
    product: productReducer,
    profile: profileReducer,
    reports: reportsReducer,
    tickets: ticketReducer,
    userSettings: userReducer,
    userBalance: userBalanceReducer,
    [authApi.reducerPath]: authApi.reducer,
    [numberApi.reducerPath]: numberApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [userContactsApi.reducerPath]: userContactsApi.reducer,
    ...billingReducers,
    ...capacityReducers,
    ...orderReducers,
    ...planReducers,
    [ticketApi.reducerPath]: ticketApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [areaApi.reducerPath]: areaApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [systemApi.reducerPath]: systemApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      numberApi.middleware,
      countryApi.middleware,
      dashboardApi.middleware,
      reportsApi.middleware,
      userApi.middleware,
      userContactsApi.middleware,
      ...billingMiddlewares,
      ...capacityMiddlewares,
      ...orderMiddlewares,
      ...planMiddlewares,
      ticketApi.middleware,
      productApi.middleware,
      areaApi.middleware,
      profileApi.middleware,
      systemApi.middleware,
      serviceUnavailableMiddleware,
      unauthenticatedMiddleware,
      rtkQueryErrorLogger,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
});
setupListeners(store.dispatch);
export default store;
